import { Experience } from '../services/experienceService';

// Use static paths instead of dynamic ones
export const mockExperiences: Experience[] = [
  {
    id: 1,
    title: 'experiences.premium.title',
    description: 'experiences.premium.description',
    price: 6000,
    // Using absolute paths without dynamic origin
    image: '/images/experiences/premium-exp.webp',
    includes: 'experiences.includes.premium'
  },
  {
    id: 2,
    title: 'experiences.standard.title',
    description: 'experiences.standard.description',
    price: 2500,
    image: '/images/experiences/standard-exp.webp',
    includes: 'experiences.includes.standard'
  },
  {
    id: 3,
    title: 'experiences.basic.title',
    description: 'experiences.basic.description',
    price: 1300,
    image: '/images/experiences/basic-exp.webp',
    includes: 'experiences.includes.basic'
  }
]; 